import http from "@/axios/http-common";
import { RiwayatObatPasien } from "@/types/riwayat_obat";

async function riwayatObat(
  rm: string | number,
  params: { bulan: number; kecuali_register?: number | null }
): Promise<RiwayatObatPasien> {
  const query: Record<string, number> = { bulan: params.bulan };

  if (params.kecuali_register) {
    query.kecuali_register = Number(params.kecuali_register);
  }

  const response = await http.getDataParam(
    `/pasien/${encodeURIComponent(String(rm))}/riwayat-obat`,
    { params: query }
  );

  return response.data as RiwayatObatPasien;
}

export default {
  riwayatObat
};
